/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { Spinner } from '@/components/AZCustomComponent/Spinner';
import styles from './styles.module.scss';

export const LoadingSpinner = () => {
  return (
    <div className={styles.container}>
      <Spinner />
    </div>
  );
};
